// src/socket.js
import { io } from "socket.io-client"; // ✅ correct for v4+

const API_URL = process.env.VUE_APP_API_BASE || "http://localhost:3000";

const socket = io(API_URL, {
  path: "/socket.io",
  transports: ["websocket", "polling"],
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 1000,
  withCredentials: true,
});

socket.on("connect", () => console.log("✅ Socket connected:", socket.id));
socket.on("disconnect", (r) => console.log("🔴 Socket disconnected:", r));
socket.on("connect_error", (e) => console.error("⚠️ Socket error:", e.message));

export default socket;